module.exports = __webpack_public_path__ + "static/media/tenants.4eaded01.png";